import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import IntegrationBanner from "@/components/IntegrationBanner";
import { useSEO } from "@/hooks/useSEO";
import ClientSpotlight from "@/components/ClientSpotlight";
import FeaturedClientSpotlight from "@/components/FeaturedClientSpotlight";
import FeaturesShowcase from "@/components/FeaturesShowcase";
import SolutionsGrid from "@/components/SolutionsGrid";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const Home = () => {
  useSEO({
    title: 'Ommni - Commerce Operations Platform for Modern Retailers',
    description: 'Unify Product, Pricing, and Inventory management with Ommni. The commerce operations platform trusted by leading retailers. 100+ integrations, real-time sync, and intelligent automation.',
    keywords: 'commerce operations platform, PIM software, inventory management, product information management, retail technology, ecommerce platform, omnichannel commerce',
    canonical: 'https://ommni.io',
  });

  return (
    <div className="min-h-screen" itemScope itemType="https://schema.org/WebPage">
      <Navigation />
      <main className="pt-16" role="main">
        <Hero />
        <IntegrationBanner />
        <ClientSpotlight />
        <FeaturesShowcase />
        <SolutionsGrid />
        <FeaturedClientSpotlight />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
